import { Action, ThunkAction, configureStore } from '@reduxjs/toolkit';

import applicationsReducer from 'features/applications/applicationsSlice';
import authReducer from 'features/auth/authSlice';
import clientReducer from 'features/client/clientSlice';
import commentsReducer from 'features/comments/commentsSlice';
import commonsReducer from 'features/commons/commonsSlice';
import createJobReducer from 'features/createJob/createJobSlice';
import dictionariesReducer from 'features/dictionaries/dictionariesSlice';
import filtersReducer from 'features/filters/filtersSlice';
import interviewSlotsReducer from 'features/interviewSlots/interviewSlotsSlice';
import jobDescriptionReducer from 'features/jobDescription/jobDescriptionSlice';
import jobsReducer from 'features/jobs/jobsSlice';
import jobseekersReducer from 'features/jobseekers/jobseekersSlice';
import localeReducer from 'features/locale/localeSlice';
import { ModuleConfigsState } from 'features/moduleConfigs/moduleConfigsSlice';
import moduleConfigsReducer from 'features/moduleConfigs/moduleConfigsSlice';
import notificationsReducer from 'features/notifications/notificationsSlice';
import pageTitleReducer from 'features/pageTitle/pageTitleSlice';
import reportsReducer from 'features/reports/reportsSlice';
import sidebarReducer from 'features/sidebar/sidebarSlice';
import tourReducer from 'features/tour/tourSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    locale: localeReducer,
    dictionaries: dictionariesReducer,
    filters: filtersReducer,
    pageTitle: pageTitleReducer,
    sidebar: sidebarReducer,
    jobs: jobsReducer,
    createJob: createJobReducer,
    jobDescription: jobDescriptionReducer,
    jobseekers: jobseekersReducer,
    applications: applicationsReducer,
    commons: commonsReducer,
    comments: commentsReducer,
    reports: reportsReducer,
    notifications: notificationsReducer,
    interviewSlots: interviewSlotsReducer,
    moduleConfigs: moduleConfigsReducer,
    client: clientReducer,
    tour: tourReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['tour/startTour', 'tour/navigatePage'],
        ignoredActionPaths: ['payload.steps', 'payload.page'],
        ignoredPaths: ['tour.steps']
      }
    })
});

export type AppDispatch = typeof store.dispatch;
export interface RootState extends ReturnType<typeof store.getState> {
  moduleConfigs: ModuleConfigsState;
}
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export default store;
